<template>
  <LayoutHeaderFullWidth />
  <div class="full-width-content">
    <NuxtPage />
  </div>
  <LayoutFooter />
  <LayoutBackToTop />
</template>

<script setup lang="ts">
</script>

<style scoped>
.full-width-content {
  width: 100%;
  margin: 0;
  padding: 0;
}
</style>
